/**
 * @generated SignedSource<<529778b37806f84b1b00f1444b38ade5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AnswerAgentQuestionInput = {
  answers: any;
  llmConversationId?: any | null | undefined;
  llmInteractionId?: any | null | undefined;
  toolUseId: string;
};
export type useAnswerAgentQuestionMutation$variables = {
  input: AnswerAgentQuestionInput;
};
export type useAnswerAgentQuestionMutation$data = {
  readonly answerAgentQuestion: {
    readonly success: boolean;
  };
};
export type useAnswerAgentQuestionMutation = {
  response: useAnswerAgentQuestionMutation$data;
  variables: useAnswerAgentQuestionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AnswerAgentQuestionPayload",
    "kind": "LinkedField",
    "name": "answerAgentQuestion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAnswerAgentQuestionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAnswerAgentQuestionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8a95b8dbad0489e8ee62bb93c5ba0aa",
    "id": null,
    "metadata": {},
    "name": "useAnswerAgentQuestionMutation",
    "operationKind": "mutation",
    "text": "mutation useAnswerAgentQuestionMutation(\n  $input: AnswerAgentQuestionInput!\n) {\n  answerAgentQuestion(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "11923c1aed61d249181b533bf4c57c43";

export default node;
